import { memo } from "react";
import { Modal } from "react-bootstrap";
import { trackEvent } from "utils/loggly-tracker";

// Helper function to extract text from JSX or return string as-is
function extractTextFromTitle(title) {
  if (!title) return "";

  // If it's already a string, return it
  if (typeof title === "string") return title;

  // If it's a number, convert to string
  if (typeof title === "number") return String(title);

  // If it's a React element, try to extract text content
  if (typeof title === "object" && title.props) {
    // If it has children, recursively extract text
    if (title.props.children) {
      const children = Array.isArray(title.props.children)
        ? title.props.children
        : [title.props.children];

      return children
        .map((child) => extractTextFromTitle(child))
        .filter(Boolean)
        .join(" ");
    }
  }

  // Fallback for other cases
  return "modal";
}

function CustomModal(props) {
  const {
    show,
    size = "md",
    title,
    titleId,
    closeLabel,
    footer,
    onHide,
    children,
    wrapperClassName = "",
    modalBodyClassName = "",
    modalBodyStyle = "",
    ...rest
  } = props;

  const titleText = extractTextFromTitle(title);

  return (
    <Modal
      show={show}
      size={size}
      onHide={() => {
        onHide(false);
        trackEvent(`close ${titleText} popup`, "click");
      }}
      {...rest}
      className={`mt-4 ${wrapperClassName}`}
    >
      <Modal.Header closeButton closeLabel={closeLabel}>
        {title ? (
          <Modal.Title className="h6" id={titleId}>
            {title}
          </Modal.Title>
        ) : null}
      </Modal.Header>
      <Modal.Body style={{ ...modalBodyStyle }} className={modalBodyClassName}>
        {children}
      </Modal.Body>
      {footer && footer() ? <Modal.Footer>{footer()}</Modal.Footer> : null}
    </Modal>
  );
}

export default memo(CustomModal);
